import { embedDashboard } from "@superset-ui/embedded-sdk";
import { useEffect } from 'react';
import { supersetService } from '../../../services/superset-service';
import { Config } from "@/core/config/config";


const SUPERSET_DOMAIN = Config.VITE_APP_SUPERSET_URL;

const SupersetStockDashboard= () => {

    useEffect(() => {
        embedDashboard({
            id: "f690991c-e6e3-4893-87b6-e00932fed657",
            supersetDomain: SUPERSET_DOMAIN!,
            mountPoint: document.querySelector("#superset-container")!, 
            fetchGuestToken: () => supersetService.getStockDashboard()
                .then((response) => response.data.token),
            dashboardUiConfig: { hideTitle: true, hideChartControls: false },

        });
    }, [])
    return (

        <div id="superset-container" className="embedded-superset">

        </div>

    );
}

export default SupersetStockDashboard;